var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 60,
    viewBox: "0 0 39 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 49.8697C0.0507812 44.3613 4.40468 39.8958 9.77539 39.8958H19.5V49.8697C19.5 55.3781 15.1461 59.8437 9.77539 59.8437C4.40468 59.8437 0.0507812 55.3781 0.0507812 49.8697Z",
    fill: "#FF7237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 49.8697C0.0507812 44.3613 4.40468 39.8958 9.77539 39.8958H19.5V49.8697C19.5 55.3781 15.1461 59.8437 9.77539 59.8437C4.40468 59.8437 0.0507812 55.3781 0.0507812 49.8697Z",
    fill: "url(#paint0_linear_26_2015)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0V19.9479H29.2246C34.5953 19.9479 38.9492 15.4824 38.9492 9.97396C38.9492 4.46554 34.5953 0 29.2246 0H19.5Z",
    fill: "#FF7237"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0V19.9479H29.2246C34.5953 19.9479 38.9492 15.4824 38.9492 9.97396C38.9492 4.46554 34.5953 0 29.2246 0H19.5Z",
    fill: "url(#paint1_linear_26_2015)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2246 39.8959C34.5954 39.8959 38.9492 35.4304 38.9492 29.922C38.9492 24.4135 34.5954 19.948 29.2246 19.948C23.8539 19.948 19.5 24.4135 19.5 29.922C19.5 35.4304 23.8539 39.8959 29.2246 39.8959Z",
    fill: "#FF7237"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2246 39.8959C34.5954 39.8959 38.9492 35.4304 38.9492 29.922C38.9492 24.4135 34.5954 19.948 29.2246 19.948C23.8539 19.948 19.5 24.4135 19.5 29.922C19.5 35.4304 23.8539 39.8959 29.2246 39.8959Z",
    fill: "url(#paint2_linear_26_2015)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 9.97396C0.0507812 15.4824 4.40468 19.9479 9.77539 19.9479H19.5V0H9.77539C4.40468 0 0.0507812 4.46554 0.0507812 9.97396Z",
    fill: "#FF7237"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 9.97396C0.0507812 15.4824 4.40468 19.9479 9.77539 19.9479H19.5V0H9.77539C4.40468 0 0.0507812 4.46554 0.0507812 9.97396Z",
    fill: "url(#paint3_linear_26_2015)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 29.922C0.0507812 35.4304 4.40468 39.8959 9.77539 39.8959H19.5V19.948H9.77539C4.40468 19.948 0.0507812 24.4135 0.0507812 29.922Z",
    fill: "#FF7237"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0507812 29.922C0.0507812 35.4304 4.40468 39.8959 9.77539 39.8959H19.5V19.948H9.77539C4.40468 19.948 0.0507812 24.4135 0.0507812 29.922Z",
    fill: "url(#paint4_linear_26_2015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_2015",
    x1: 0.0507812,
    y1: 49.8697,
    x2: 19.5,
    y2: 49.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_2015",
    x1: 19.5,
    y1: 9.97396,
    x2: 38.9492,
    y2: 9.97396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_2015",
    x1: 19.5,
    y1: 29.922,
    x2: 38.9492,
    y2: 29.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_2015",
    x1: 0.0507812,
    y1: 9.97396,
    x2: 19.5,
    y2: 9.97396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26_2015",
    x1: 0.0507812,
    y1: 29.922,
    x2: 19.5,
    y2: 29.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.9e23f97bdff77a80899538d3f02da468.svg";
export { ForwardRef as ReactComponent };